import Account from '@/entities/Account.js';
import { useAccountStore } from '@/store/modules/account/store.js';
import { useContextStore } from '@/store/modules/context/store.ts';

export function findContextAccount(accountId) {
    const accountStore = useAccountStore();
    const contextStore = useContextStore();
    const contextAccount = accountStore.contextAccount;

    if (!contextAccount) {
        return null;
    }

    if (contextAccount.id === accountId) {
        return contextAccount;
    }

    let account =
        contextAccount.children?.find((a) => a.id === accountId) ||
        contextAccount.parents?.find((a) => a.id === accountId);

    if (account) {
        return account;
    }

    if (contextStore.group?.accounts) {
        account = contextStore.group.accounts.find((a) => a.id === accountId);
        if (account) {
            return new Account(account);
        }
    }

    return null;
}
